import { usePostHog } from "posthog-js/react"
import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { syncPostHogFromStorage } from "../../utils/posthogAnalytics"


const PostHogPageviewTracker = () => {
    const location = useLocation()
    const posthog = usePostHog()

    useEffect(()=> {
        if(posthog){
            syncPostHogFromStorage()
            posthog.capture('$pageview')
        }

    },[location, posthog])

    return null

}

export default PostHogPageviewTracker